<template>
  <ais-instant-search :search-client="searchClient" :index-name="indexName" :middlewares="middlewares" :id="index">
    <ais-configure
      v-if="filters"
      :hitsPerPage="limit"
      :facetFilters="filters"
    />

    <ais-configure
      v-else
      :hitsPerPage="12"
    />

    <div v-if="eventCategoryFilter.length">
      <h3 :class="`text-${theme} container lg:text-center font-crimson text-2xl`">
        Or filter by category
      </h3>

      <div class="container grid grid-cols-2 my-4 gap-x-4 gap-y-2 mx-auto text-white lg:px-0 lg:flex lg:justify-center lg:flex-wrap max-w-[1094px]">
        <button @click="changeCategory(null)" :class="`button
          ${!selectedCategory ? `bg-white border text-${theme} border-${theme}` : `bg-${theme}`}
        `">
          All
        </button>

        <button v-for="category in eventCategoryFilter" :key="category.id" @click="changeCategory(category.id)" :class="`
          button
          ${selectedCategory == category.id ? `bg-white border text-${theme} border-${theme}` : `bg-${theme}`}
        `">
          {{ category.title }}
        </button>
      </div>
    </div>

    <!-- Results -->
    <ais-hits v-slot="{ items, sendEvent }" :class="classes.mainSection">
      <div v-if="(sectionTitle.title || sectionTitle.subtitle || sectionTitle.button.url || sectionTitle.button.text) && items.length" class="mb-8">
        <h3 v-if="sectionTitle.title" :class="`font-crimson text-center text-${textWhite ? 'white' : theme} text-3xl lg:text-[40px]`">
          {{ sectionTitle.title }}
        </h3>

        <p v-if="sectionTitle.subtitle" :class="`mt-2 text-lg leading-6 lg:max-w-[670px] lg:mx-auto lg:mt-4 text-center 
          text-${textWhite ? 'white' : theme}`"
        >
          {{ sectionTitle.subtitle }}
        </p>

        <a v-if="sectionTitle.button && sectionTitle.button.text && sectionTitle.button.url" :href="sectionTitle.button.url" 
          :class="`button mx-auto mt-4 w-52 hover-shadow border border-white hover:bg-purple-light hover:text-white 
          ${textWhite ? `bg-white text-${theme}` : `bg-${theme} text-white`}`"
        >
          {{ sectionTitle.button.text }}
        </a>
      </div>

      <div :class="classes.container" v-if="items.length">
        <medium-card
          v-if="cardType == 'medium'"
          v-for="item in items"
          :key="item.objectID"
          :item="item"
          :sendEvent="sendEvent"
          :theme="theme"
          :filterCard="filterCard"
        />

        <mini-card 
          v-if="cardType == 'mini'"
          v-for="item in items"
          :key="item.objectID"
          :cardTitle="item.title"
          :image="item.image"
          :url="item.uri"
          :theme="theme"
          :previewText="item.previewText"
          :filterCard="filterCard"
          tag="Event"
        />
      </div>

      <!-- Pagination -->
      <pagination v-if="paginate && items.length" :scrollToSelector="`#${index}`" :theme="theme" />
    </ais-hits>
  </ais-instant-search>
</template>

<script>
  import algoliasearch from 'algoliasearch/lite';
  import aa from 'search-insights';
  import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
  import MediumCard from "./components/cards/Medium";
  import MiniCard from "./components/cards/Mini";
  import Pagination from "./components/Pagination";
  import { AisInstantSearch, AisHits, AisConfigure } from 'vue-instantsearch';
  
  const algoliaClient = algoliasearch(
    process.env.MIX_ALGOLIA_APPLICATION_ID,
    process.env.MIX_ALGOLIA_SEARCH_API_KEY
  );

  const searchClient = {
    ...algoliaClient,
    search(requests) {
      return algoliaClient.search(requests);
    },
  };

  const insightsMiddleware = createInsightsMiddleware({
    insightsClient: aa,
    insightsInitParams: {
      useCookie: true,
    }
  })

export default {
  name: "EventsList",
  props: {
    classes: {
      type: Object,
      default: () => ({
        container: 'container flex flex-wrap mb-10 gap-8 justify-center md:grid md:grid-cols-2 xl:grid-cols-4',
        mainSection: 'pt-14 lg:pt-24 lg:mb-6',
      }),
    },
    theme: {
      type: String,
      default: 'purple',
    },
    eventCategoryFilter: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: [],
    },
    featured: {
      type: Boolean,
      default: false,
    },
    paginate: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 12,
    },
    sectionTitle: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: '',
        button: {
          text: '',
          url: '',
        }
      })
    },
    index: {
      type: String,
      default: 'events-list',
    },
    textWhite: {
      type: Boolean,
      default: false,
    },
    filterCard: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: 'medium',
    },
  },
  components: {
    MediumCard,
    Pagination,
    AisInstantSearch,
    AisHits,
    AisConfigure,
    MiniCard
  },
  data() {
    return {
      searchClient,
      indexName: process.env.MIX_ALGOLIA_EVENTS_INDEX,
      middlewares: [insightsMiddleware],
      selectedCategory: null,
    };
  },
  methods: {
    changeCategory(categoryId) {
      this.selectedCategory = categoryId;

      document.querySelector(`#${this.index}`).scrollIntoView({
        behavior: 'smooth'
      });
    },
  },
  computed: {
    filters() {
      let filters = [];
      if (this.categories[0]) {
        filters.push(this.categories.map(category => `categories:${category}`));
      } else if (this.selectedCategory) {
        filters.push(`categories:${this.selectedCategory}`);
      }

      if (this.featured) {
        filters.push("featuredEntry:true");
      }

      return filters ? filters : null;
    },
  },
};
</script>

